<template>
  <fragment>
    <v-navigation-drawer
      v-model="showDrawer"
      :permanent="lgAndUp"
      v-click-outside="handleDrawer"
      color="tertiary"
      width="220"
      app
      dark
      floating
    >
      <template v-slot:prepend>
        <v-list class="pa-0">
          <v-list-item>
            <v-list-item-content class="py-0">
              <v-img
                :src="require(`@/assets/${companyLink.icon}`)"
                :alt="companyLink.name"
                :height="companyLink.height"
                :width="companyLink.width"
                :contain="companyLink.contain"
              />
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <v-list dense flat>
        <template v-for="(item, index) in adminSidebar">
          <v-list-group
            v-if="item.options.length > 0"
            :key="index + item.title"
            no-action
          >
            <template v-slot:activator>
              <template>
                <v-list-item-icon class="mr-6">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </template>
            </template>

            <template v-for="(option, index) in item.options">
              <v-list-item
                v-if="!option.hasChildren"
                :key="option.title + index"
                :to="{ name: option.link, params: option.params }"
                link
                class="px-4"
              >
                <v-list-item-content>
                  <v-list-item-title
                    v-text="option.title"
                    style="font-size: 12px"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <template v-for="(option, index) in item.options">
              <v-list-group
                class="custom-group"
                v-if="option.hasChildren"
                :key="index"
                sub-group
                no-action
              >
                <template v-slot:activator>
                  <v-list-item-title
                    v-text="option.title"
                    style="font-size: 12px !important"
                  ></v-list-item-title>
                </template>

                <v-list-item
                  class="custom-sub-group-item"
                  v-for="(subOptions, index) in option.subOptions"
                  :to="{ name: subOptions.link, params: subOptions.params }"
                  :key="index"
                >
                  <v-list-item-title
                    v-text="subOptions.title"
                    style="font-size: 12px !important"
                  ></v-list-item-title>
                </v-list-item>
              </v-list-group>
            </template>
          </v-list-group>

          <v-list-item
            v-else
            :key="item.title"
            :to="{ name: item.link, params: item.params }"
            link
          >
            <template>
              <v-list-item-icon class="mr-6">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </fragment>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";

export default {
  name: "AppSideBar",
  mixins: [displayHelpers],
  data() {
    return {
      showDrawer: null,
    };
  },
  computed: {
    ...mapGetters(["storeInfo", "isAdmin", "drawer"]),
    adminSidebar() {
      return [
        {
          title: this.$t("eleven-dashboard.title"),
          icon: "mdi-view-dashboard-outline",
          cypress: "sidebar-Dashboard",
          link: "home",
          params: {},
          options: [],
        },
        {
          title: this.$t("producer-dashboard.title"),
          icon: "mdi-view-dashboard-variant",
          cypress: "sidebar-Dashboard-Produtor",
          link: "dashboard-produtor",
          params: {},
          options: [],
        },
        {
          title: this.$t("digital-wallet.title"),
          icon: "mdi-wallet",
          cypress: "sidebar-Carteira-Digital",
          link: "digitalWallet",
          params: {},
          options: [],
        },
        {
          title: this.$t("reports.title"),
          icon: "mdi-chart-bar",
          cypress: "sidebar-Relatórios",
          link: "",
          params: {},
          options: [
            {
              title: this.$t("reports.general-sales.title"),
              cypress: "",
              link: "generalAnalytical",
              params: {},
            },
            {
              title: this.$t("reports.eleven.title"),
              cypress: "",
              link: "",
              params: {},
              hasChildren: true,
              subOptions: [
                {
                  title: this.$t("reports.financial-producer.title"),
                  cypress: "",
                  link: "financialAnalytical",
                  params: {},
                },
                {
                  title: this.$t("reports.nf-consumer.title"),
                  cypress: "",
                  link: "consumerFiscalNote",
                  params: {},
                },
                {
                  title: this.$t("reports.detailed-sale"),
                  cypress: "",
                  link: "generalAnalyticalEleventickets",
                  params: {},
                },
                {
                  title: this.$t("reports.products-sales.title"),
                  cypress: "",
                  link: "productsSales",
                  params: "",
                },
                {
                  title: this.$t("reports.eleven.financial"),
                  cypress: "",
                  link: "financialAnalyticalEleventickets",
                  params: {},
                },
                {
                  title: this.$t("reports.eleven.consumers"),
                  cypress: "",
                  link: "consumerAnalytical",
                  params: {},
                },
              ],
            },
          ],
        },
        {
          title: this.$t("registrations.title"),
          icon: "mdi-storefront",
          cypress: "sidebar-Lojas",
          link: "",
          params: {},
          options: [
            {
              title: this.$t("registrations.producers.title"),
              cypress: "sidebar-Lojas-gerenciar",
              link: "producers",
              params: {},
            },
            {
              title: this.$t("registrations.segment.title"),
              cypress: "sidebar-Lojas-seguimentos",
              link: "segments",
              params: {},
            },
            {
              title: this.$t("registrations.users.title"),
              cypress: "sidebar-Lojas-usuarios",
              link: "producersUsers",
              params: {},
            },
            {
              title: this.$t("registrations.payment-rules.title"),
              cypress: "sidebar-Lojas-pagamento",
              link: "paymentMethods",
              params: {},
            },
            {
              title: this.$t("registrations.integrations.title"),
              link: "integrations",
              params: {},
            },
          ],
        },
        {
          title: this.$t("events.title"),
          icon: "mdi-calendar",
          cypress: "sidebar-Produtos",
          link: "",
          params: {},
          options: [
            {
              title: this.$t("events.event-config.create-edit"),
              cypress: "sidebar-Produtos-Gerenciar",
              link: "events",
              params: {},
            },
            {
              title: this.$t("events.categories.title"),
              cypress: "sidebar-Produtos-Categorias",
              link: "categories",
              params: {},
            },
            {
              title: "Combos",
              icon: "mdi-package-variant-closed-plus",
              cypress: "sidebar-Produtos-Combos",
              link: "combos",
              params: {},
            },
            {
              title: this.$t("events.ordering.title"),
              cypress: "sidebar-Produtos-Ordenacao",
              link: "order",
              params: {},
            },
          ],
        },
        {
          title: this.$t("sales.title"),
          icon: "mdi-sale",
          cypress: "sidebar-Vendas",
          link: "",
          params: {},
          options: [
            {
              title: this.$t("sales.manage"),
              cypress: "sidebar-Vendas-gerenciar",
              link: "sales",
              params: {},
            },
            {
              title: this.$t("sales.discount-coupon.title"),
              cypress: "sidebar-Vendas-cupom-desconto",
              link: "discountCoupon",
              params: {},
            },
            {
              title: this.$t("sales.ticket_package_title"),
              cypress: "sidebar-Vendas-pacote-ingresso",
              link: "ticketPackage",
              params: {},
            },
            {
              title: this.$t("sales.points-of-sale"),
              icon: "mdi-point-of-sale",
              cypress: "sidebar-Pessoas-Pontos-de-Venda",
              link: "salePoint",
              params: {},
            },
            {
              title: this.$t("sales.points-of-sale-types"),
              icon: "mdi-network-pos",
              cypress: "sidebar-Pessoas-Tipos-de-Pontos-de-Venda",
              link: "salePointType",
              params: {},
            },
            {
              title: this.$t("sales.equipments"),
              icon: "mdi-cellphone-marker",
              cypress: "sidebar-Operações-Equipamentos",
              link: "equipments",
              params: {},
            },
            {
              title: this.$t("sales.affiliates_program"),
              icon: "mdi-handshake-outline",
              cypress: "sidebar-Vendas-programa-afiliados",
              link: "afilliatesProgram",
              params: {},
            },
          ],
        },
        {
          title: this.$t("customers.title"),
          icon: "mdi-account-multiple",
          cypress: "sidebar-Lojas-consumidor",
          link: "consumers",
          params: {},
          options: [],
        },
        {
          title: "Check-in",
          icon: "mdi-clipboard-check",
          cypress: "sidebar-checkin",
          link: "checkin",
          params: {},
          options: [],
        },
        {
          title: this.$t("financial.title"),
          icon: "mdi-finance",
          cypress: "sidebar-Financeiro",
          link: "",
          params: {},
          options: [
            {
              title: this.$t("financial.regionals.title"),
              cypress: "sidebar-Financeiro-Regionais",
              link: "regional",
              params: {},
            },
            {
              title: this.$t("financial.payment-methods.title"),
              cypress: "sidebar-Financeiro-Formas-de-Pagamentos",
              link: "financePaymentMethods",
              params: {},
            },
          ],
        },
        {
          title: this.$t("people.title"),
          icon: "mdi-account-group",
          cypress: "sidebar-Pessoas-Usuários",
          link: "",
          params: {},
          options: [
            {
              title: this.$t("people.users.eleven-admin"),
              cypress: "sidebar-Pessoas-Usuários",
              link: "users",
              params: {},
            },
            {
              title: this.$t("people.affiliates.title"),
              cypress: "sidebar-Pessoas-Afiliados",
              link: "affiliates",
              params: {},
            },
          ],
        },
        {
          title: "Marketing",
          icon: "mdi-bullhorn",
          cypress: "sidebar-Marketing",
          link: "",
          params: {},
          options: [
            {
              title: this.$t("marketing.settings.title"),
              link: "marketing",
              params: {},
            },
            {
              title: this.$t("marketing.invitation.title"),
              link: "invitation",
              params: {},
            },
          ],
        },
        {
          title: this.$t("settings.title"),
          icon: "mdi-tune-vertical",
          link: "configuracoes-omnichannel",
          params: {},
          options: [],
        },
        {
          title: this.$t("terms.title"),
          icon: "mdi-clipboard-edit",
          cypress: "sidebar-Termos",
          link: "termos",
          params: {},
          options: [],
        },
      ];
    },
    companyLink() {
      return {
        icon: "Eleven_Tickets_Negativo_Horizontal.svg",
        link: `${process.env.VUE_APP_PANEL_URL}dashboard`,
        height: 56,
        width: "100%",
        name: "eleventickets",
        contain: true,
      };
    },
  },
  watch: {
    drawer() {
      this.showDrawer = this.drawer;
    },
    showDrawer() {
      if (!this.showDrawer) this.toggleDrawer(false);
    },
  },
  mounted() {
    if (!this.showDrawer) this.toggleDrawer(false);
  },
  methods: {
    ...mapActions(["setStoreSelector"]),
    ...mapMutations(["toggleDrawer"]),
    handleDrawer() {
      if (!this.showDrawer) this.toggleDrawer(false);
    },
  },
};
</script>

<style scoped lang="scss">
.btn-open-menu:hover {
  color: var(--v-primary-base) !important;
  cursor: pointer;
}
.custom-group >>> .v-list-group__header {
  padding-left: 16px !important;
  flex-direction: row-reverse;
}

.custom-group >>> .v-list-group__header .v-list-group__header__prepend-icon {
  margin-right: 0 !important;
}
.custom-sub-group-item {
  padding: 0 0 0 16px !important;
}

* {
  color: #ffffff !important;
}
</style>
